import request from '@/services/request'

export function fetchAll(data) {
  return request({
    url: process.env.BASE_URL_USER + '/client/list',
    method: 'get',
    params: data
  })
}

export function get(data) {
  return request({
    url: process.env.BASE_URL_USER + '/client/detail',
    method: 'get',
    params: data
  })
}

export function create(data) {
  return request({
    url: process.env.BASE_URL_USER + '/client/create',
    method: 'post',
    data: data
  })
}

export function update(data) {
  return request({
    url: process.env.BASE_URL_USER + '/client/update',
    method: 'put',
    data: data
  })
}







// WEBPACK FOOTER //
// ./src/api/client.js